import { call, put, takeLatest } from 'redux-saga/effects';
import moment from 'moment';

import config from '@config';
import { setLoad } from '@store/actions/ux';
import { actions } from '@search/store/actions/requests';
import { addResults } from '@search/store/actions/results';
import API from '@api';

function* searchPrograms(action) {
  try {
    yield put(
      setLoad({
        searchCatchup: true,
        searchTvguide: true,
      }),
    );
    const programs = yield call(
      API.getProgramSearch.bind(API),
      action.query,
      action.nid,
    );
    yield put(
      addResults(
        programs.map(p => {
          return {
            ...p,
            type: 'recommendations',
          };
        }),
      ),
    );
    yield put(
      setLoad({
        searchCatchup: false,
      }),
    );

    let programsFound = 0;
    for (let i = 0; i <= 7; i++) {
      if (programsFound >= config.maxSearchResults) {
        break;
      }

      const tvguidePrograms = yield call(
        API.getTvGuidePrograms.bind(API),
        action.nid,
        moment
          .utc()
          .startOf('day')
          .add(i, 'day')
          .unix(),
      );
      const tvgpToAdd = tvguidePrograms
        .filter(p => {
          return (
            p.main_title.length > 0 &&
            p.main_title.toLowerCase().includes(action.query.toLowerCase())
          );
        })
        .slice(0, config.maxSearchResults);

      programsFound += tvgpToAdd.length;
      yield put(
        addResults(
          tvgpToAdd.map(p => {
            return {
              ...p,
              type: 'tvguide',
            };
          }),
        ),
      );

      if (tvgpToAdd.length > 0) {
        yield put(
          setLoad({
            searchTvguide: false,
          }),
        );
      }
    }

    yield put(
      setLoad({
        searchTvguide: false,
      }),
    );
  } catch (e) {
    console.error(e);
  }
}

function* searchSaga() {
  yield takeLatest(actions.search, searchPrograms);
}

export default searchSaga;
